// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ba-3";
export var contentContainer = "_ba-0";
export var editorContainer = "_ba-1";
export var quillInputForm = "_ba-2";
export var zoneDivider = "_ba-4";